const parseJson = (raw, defaultValue = {}) => {
  try {
    if (raw == null || raw === '') return defaultValue;
    return JSON.parse(raw);
  } catch (e) {
    return defaultValue;
  }
};

export default class BrowserUtil {
  static isBrowser = () => typeof window !== "undefined";

  static getHostname = () => window?.location?.hostname;

  static getItemFromLocalStorage = (key, defaultValue = {}) => {
    if (!BrowserUtil.isBrowser()) return defaultValue;

    try {
      const item = localStorage.getItem(key);
      return parseJson(item, defaultValue);
    } catch (e) {
      return defaultValue;
    }
  }

  static setItemInLocalStorage = (key, value) => {
    if (!BrowserUtil.isBrowser()) return;

    try
    {
      localStorage.setItem(key, JSON.stringify(value));
    }
    catch(e)
    {
    }
  }

  static removeItemFromLocalStorage = (key) => {
    if (!BrowserUtil.isBrowser()) return;

    try
    {
      localStorage.removeItem(key);
    }
    catch(e)
    {
    }
  }

  static getItemFromSessionStorage = (key, defaultValue = {}) => {
    if (!BrowserUtil.isBrowser()) return defaultValue;

    try {
      const item = sessionStorage.getItem(key);
      return parseJson(item, defaultValue);
    } catch (e) {
      return defaultValue;
    }
  }

  static setItemInSessionStorage = (key, value) => {
    if (!BrowserUtil.isBrowser()) return;

    try
    {
      sessionStorage.setItem(key, JSON.stringify(value));
    }
    catch(e)
    {
    }
  }

  static async copyText(text) {
    if (!BrowserUtil.isBrowser()) return;

    try {
      await navigator.clipboard.writeText(text);
    } catch (err) {
      console.error("Failed to copy text:", err);
    }
  }
}
